import setAvailable from './set-available.reducer';
import addAvailable from './add-available.reducer';
import updateTotalCount from './update-total-count.reducer';
import toggleItem from './toggle-item.reducer';
import toggleAll from './toggle-all.reducer';
import cancelAllExisting from './cancel-all-existing.reducer';
import selectAllExisting from './select-all-existing.reducer';
import { nextPage, prevPage, setPage } from './change-page.reducer';
import reset from './reset.reducer';
import updateSearch from './update-search.reducer';

export default {
  setAvailable,
  addAvailable,
  toggleItem,
  toggleAll,
  cancelAllExisting,
  selectAllExisting,
  updateTotalCount,
  updateSearch,
  nextPage,
  prevPage,
  setPage,
  reset,
};
